import React from 'react';

function ScreenHeader({title, children}){

  return(
    <div className="header">        
        <div className="title">
          <h2>{title}</h2>
        </div>
        <div className="actions">
          <div className="action">
            {children}            
          </div>
        </div>
    </div>
  )
}

export default ScreenHeader;